import React from "react";
// import { Line } from "react-chartjs-2";
import BoltIcon from "@mui/icons-material/Bolt";
import BatteryChargingFullIcon from "@mui/icons-material/BatteryChargingFull";
import ElectricalServicesIcon from "@mui/icons-material/ElectricalServices";
import ThermostatIcon from '@mui/icons-material/Thermostat';
import "./Chart.css";

// const skipped = (ctx, value) =>
//   ctx.p0.skip || ctx.p1.skip ? value : undefined;
// const down = (ctx, value) =>
//   ctx.p0.parsed.y > ctx.p1.parsed.y ? value : undefined;

const chartDetails = {
  current: {
    name: "Current",
    icon: <ElectricalServicesIcon color="primary" fontSize="large" />,
    unit: "A",
  },
  voltage: {
    name: "Voltage",
    icon: <BoltIcon color="primary" fontSize="large" />,
    unit: "V",
  },
  capacity: {
    name: "Capacity",
    icon: <BatteryChargingFullIcon color="primary" fontSize="large" />,
    unit: "Ah",
  },
  temperature: {
    name: "Temperature",
    icon: <ThermostatIcon color="primary" fontSize="large" />,
    unit: "°C",
  },
};

function LineChart({ chartType = "voltage", value }) {
  const { name, icon, unit } =
    chartDetails[chartType] || chartDetails["voltage"];

  return (
    <div className="chart-container">
      <div className="chart-info">
        <div className="title">
          {icon}
          <span className="title-name">{name}</span>
        </div>
        <div className="value-box">
          <div className="value">{value}</div>
          <span className="unit">{unit}</span>
        </div>
      </div>
      {/* <Line
        data={{
          labels: chartData.labels,
          datasets: [
            {
              label: chartType,
              data: chartData.data,
              borderColor: "rgb(128, 237, 153)",
              segment: {
                borderColor: (ctx) =>
                  skipped(ctx, "rgb(0,0,0,0.2)") || down(ctx, "rgb(192,75,75)"),
                borderDash: (ctx) => skipped(ctx, [6, 6]),
              },
              spanGaps: true,
            },
          ],
        }}
        options={{
          responsive: true,
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
            },
          },
        }}
      /> */}
    </div>
  );
}

export default LineChart;
